import React, { useState } from 'react';
import { SpaceBetween, Alert, Tabs } from '@cloudscape-design/components';
import BrandSetup from './BrandSetup.jsx';
import GenerateSection from './GenerateSection.jsx';
import JobHistory from './JobHistory.jsx';
import './product-image-gen.css';

export default function ProductImageGen() {
  const [activeTab, setActiveTab] = useState('generate');
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [error, setError] = useState('');

  const handleGenComplete = () => {
    setRefreshTrigger(prev => prev + 1);
    setError('');
  };

  return (
    <div className="pigen-page">
      <div className="pigen-container">
        <div className="pigen-hero">
          <div className="pigen-hero-icon">🎯</div>
          <div className="pigen-hero-text">
            <h1 className="pigen-hero-title">Product Image Generator</h1>
            <p className="pigen-hero-subtitle">AI-powered PDP images — 6 optimized shots per product</p>
            <div className="pigen-hero-status">
              <span className="pigen-status-dot"></span>
              <span>Powered by Bedrock Claude + Titan</span>
              <span className="pigen-status-sep">|</span>
              <span>16 D2C categories supported</span>
            </div>
          </div>
        </div>

        <div className="pigen-content">
          <SpaceBetween size="l">
            {error && <Alert type="error" dismissible onDismiss={() => setError('')}>{error}</Alert>}

            <Tabs
              activeTabId={activeTab}
              onChange={({ detail }) => setActiveTab(detail.activeTabId)}
              tabs={[
                {
                  id: 'generate',
                  label: '🖼️ Generate Images',
                  content: <GenerateSection onGenComplete={handleGenComplete} />
                },
                {
                  id: 'brands',
                  label: '🏷️ Brand Setup',
                  content: <BrandSetup />
                },
                {
                  id: 'history',
                  label: '📋 History',
                  content: <JobHistory refreshTrigger={refreshTrigger} />
                },
              ]}
            />
          </SpaceBetween>
        </div>
      </div>
    </div>
  );
}
